<mat-form-field class="min-w-48 tags-multi-select" appearance="outline">
    <mat-label>{{ 'TAG.MESSAGE.FILTER_BY' | translate }}</mat-label>
    <mat-select
        [formControl]="tagMultiSelectService.tagCtrl"
        multiple
        panelClass="tags-multi-select-panel"
        (selectionChange)="tagMultiSelectService.tagSelected($event, storageKey)"
        [compareWith]="compareTags"
    >
        <mat-select-trigger>
            <span class="tags-trigger" *ngIf="tagMultiSelectService.selectedTags.length">
                <span class="selected-tag">
                    {{ tagMultiSelectService.selectedTags[0].name }}
                </span>
                <span *ngIf="tagMultiSelectService.selectedTags.length > 1" class="other-count text-xs text-opacity-75">
                    (+{{ tagMultiSelectService.selectedTags.length - 1 }} {{ 'GENERAL.LABEL.OTHER' | translate: { total: tagMultiSelectService.selectedTags.length } }})
                </span>
            </span>
        </mat-select-trigger>

        <mat-option *ngFor="let tag of tags | filterTagsByCategory: 'module'; trackBy: trackById" [value]="tag">
            <mat-chip [style.background]="tag.color" [disableRipple]="true">
                <span class="text-xs" [matTooltip]="tag.name" [matTooltipShowDelay]="400">{{ tag.name }}</span>
            </mat-chip>
        </mat-option>
    </mat-select>
</mat-form-field>
